// What is in the nav, in one list, because the bar and the phone panel both
// render it and a header whose two halves disagree is the bug this rebuild
// exists to stop.
//
// WHY THESE AND NOT MORE. The brief asked whether two items is right now that
// the page below has a services link, a prices link and an areas list. It is
// not, but the answer is three and not six:
//
//   Services & pricing  the one real destination the site has. /pricing was
//                       killed in September and redirects here (routes.js), so
//                       a separate "Prices" item is the same page twice.
//   FAQs                a real route, and it answers the objection the fold
//                       cannot: what happens if it rains, what if nobody is
//                       in, what counts as a large car. It was already in the
//                       footer and nowhere else.
//
// Deliberately NOT here:
//
//   Areas       there is no areas page to link to. The list is a home-page
//               section (#areas, sections/areas-cta) and the area pages are
//               SEO landing pages, not navigation. An in-page anchor in a
//               global header is dead on every other route.
//   Book a wash the fold already carries three bookable prices and the page
//               ends on a centred CTA. A filled button up here would be the
//               loudest thing on the first screen, which is precisely the
//               fault being fixed, in a different colour.
//   Sign in     customers book without an account. It is added below only
//               when there is a session to end.
//
// 6 Oct 2026: "Services & pricing" is "Prices" now that the Washes menu
// (./washes-menu.js) sits in front of it and carries the services; /services
// is the comparison table, which is what "mobile car wash prices" searchers
// want (COMPETITOR_REVIEW_THEVALETERS_2026-10-06 §5).
//
// Copy is sentence case (DESIGN.md §3: no uppercase outside .gwmc-eyebrow)
// and carries no em dash.
export const NAV_LINKS = [
  { to: '/services', label: 'Prices' },
  { to: '/faqs', label: 'FAQs' }
]

// The opener the WhatsApp control sends. One string, both renderers, so the
// bar and the panel never start two different conversations.
export const WHATSAPP_MESSAGE = "Hi GoWashMyCar! 👋 I'd like to chat about a wash."
